export default {"src":"/_next/static/media/FAM_LogoKlein_Color.c3cc2357.svg","height":10640,"width":10640,"blurWidth":0,"blurHeight":0};